<ng-container *ngrxLet="paymentMethodsTranslations$ as paymentMethodsTranslations">
  @if ((customerPaymentMethods$ | async); as customerPaymentMethods) {
    <div class="cart-payment">
      <div class="cart-payment-title"> {{ 'CART.PAYMENT_TITLE' | transloco }}</div>
      @if (control?.touched && (errors$ | async); as errors) {
        <div
          @errorInOutAnimation
          class="cart-payment-errors">
          @if (errors['required']) {
            <mat-error>{{ errors['required'] }}</mat-error>
          }
        </div>
      }
      <div class="cart-payment-list">
        @for (customerPaymentMethod of customerPaymentMethods; track customerPaymentMethod) {
          <div
            (click)="!readonly && selectPaymentMethod(customerPaymentMethod)"
            class="cart-payment-list-item payment-method-{{customerPaymentMethod.type.toLowerCase().replace(' ','-')}}"
            [ngClass]="{'selected': isSelected(customerPaymentMethod), 'disabled': readonly}">
            <mat-icon customSvgIcon="{{customerPaymentMethod.type.toLowerCase().replace(' ','-')}}"
            class="cart-payment-list-item-logo"></mat-icon>
            <div class="cart-payment-list-item-name">
              {{ paymentMethodsTranslations[customerPaymentMethod.name.toLocaleUpperCase()] || customerPaymentMethod.name }}
            </div>
            @if (customerPaymentMethod.balance !== null) {
              <div class="cart-payment-list-item-expirationDate">{{ customerPaymentMethod.expirationDate }}</div>
              <div class="cart-payment-list-item-balance"> {{customerPaymentMethod.balance | translocoCurrency: "symbol":{ minimumFractionDigits: 2 }:"EUR"}} </div>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-container>
